<template>
    <div>
        <section class="hero">
            <div class="hero-body">
                <div class="container">
                    <div class="pull-right">
                        <report-settings></report-settings>
                    </div>
                    <h1 class="title">
                        <span v-if="$route.name === 'reports'">
                            Reports
                        </span>
                        <span v-else>
                            <router-link :to="{ name: 'reports' }">
                                Reports
                            </router-link>
                            &rarr;
                            <span v-if="$route.name === 'sales-by-pack'">
                                Sales by Pack
                            </span>
                        </span>
                    </h1>
                </div>
            </div>
        </section>
        <div class="container">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    export default {
        name: 'reports',
        data () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// Reports.vue?1b5654d8